import { render, staticRenderFns } from "./priority.vue?vue&type=template&id=cc42daf8&scoped=true&"
import script from "./priority.vue?vue&type=script&lang=js&"
export * from "./priority.vue?vue&type=script&lang=js&"
import style0 from "./priority.vue?vue&type=style&index=0&id=cc42daf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc42daf8",
  null
  
)

export default component.exports